/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown>, count: NonNullable<unknown> }} Sync_Phase_Collecting_StepInputs */



/**
* | output |
* | --- |
* | "Collecting {step}... ({count})" |
*
* @param {Sync_Phase_Collecting_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_phase_collecting_step = /** @type {((inputs: Sync_Phase_Collecting_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Phase_Collecting_StepInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.step} werden gesammelt... (${i?.count})`)
	return /** @type {LocalizedString} */ (`Collecting ${i?.step}... (${i?.count})`)
});